// @mui
import { styled } from "@mui/material/styles";
import { ListItemIcon, ListItemButton } from "@mui/material";
// config
import { ICON } from "../../../config/nav";
import colors from "../../../config/colors";

// ----------------------------------------------------------------------

export const StyledItem = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== "active",
})(({ active, disabled }) => {
  const activeStyle = {
    color: colors.primary500,
    backgroundColor: "white",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  };

  return {
    position: "relative",
    textTransform: "capitalize",
    padding: "12px",
    color: "white",
    borderRadius: 4,
    // Active item
    ...(active && {
      ...activeStyle,
      "&:hover": {
        ...activeStyle,
      },
    }),
    // Disabled
    ...(disabled && {
      "&.Mui-disabled": {
        opacity: 0.9,
      },
    }),
  };
});

// ----------------------------------------------------------------------

export const StyledIcon = styled(ListItemIcon, {
  shouldForwardProp: (prop) => prop !== "active",
})(({ active }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: ICON.NAV_ITEM,
  height: ICON.NAV_ITEM,
  color: active ? colors.primary500 : "white",
}));

// ----------------------------------------------------------------------
